<template>
  <div class="index" id="index">
    <div class="search">
      <div class="input">
        <input type="text" name id placeholder="搜索" @click="search()" readonly />
        <img src="../../assets/img/index/search.png" alt />
      </div>
      <div class="xiaoxi" @click="jump(9)">
        <img src="../../assets/img/index/xiaoxi.png" alt />
        <p>消息</p>
      </div>
    </div>

    <div class="indexMain" id="indexMain">
      <div class="top">
        <div class="zw"></div>
        <div class="banner">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(item,index) in bannerList" :key="index">
              <img :src=" item.pic_url ? item.pic_url : $store.state.defaultbanner" alt />
            </van-swipe-item>
          </van-swipe>
        </div>

        <div class="passageway">
          <div @click="jump(1)">
            <div class="img">
              <img src="../../assets/img/index/commodity.png" alt />
            </div>
            <p>重消商品</p>
          </div>
          <div @click="jump(2)">
            <div class="img">
              <img src="../../assets/img/index/Returnedgoods.png" alt />
            </div>
            <p>返佣商品</p>
          </div>
          <div @click="jump(3)">
            <div class="img">
              <img src="../../assets/img/index/Morecategories.png" alt />
            </div>
            <p>商品分类</p>
          </div>
          <div @click="jump(4)">
            <div class="img">
              <img src="../../assets/img/index/Merchantlist.png" alt />
            </div>
            <p>商家列表</p>
          </div>
          <div @click="jump(5)">
            <div class="img">
              <img src="../../assets/img/index/cuncuntong.png" alt />
            </div>
            <p>村村通</p>
          </div>
        </div>
      </div>
      <div class="luckDraw">
        <div class="tj" @click="jump(10)">
          <img src="../../assets/img/index/xinrenchoujiang.png" alt />
        </div>
        <div class="cj">
          <div class="cp">
            <div @click="jump(6,obj)" v-for="(obj,i) in tjGoods" :key="i">
              <h3>{{obj.goods_name}}</h3>
              <div class="img">
                <img :src="obj.original ? obj.original : $store.state.defaultcjsp" alt />
              </div>
              <div class="jq">{{obj.price}}元</div>
            </div>
          </div>
        </div>
        <div class="yl">
          <div @click="jump(7)">
            <img src="../../assets/img/index/chongzhi.png" alt />
          </div>
          <div @click="jump(8)">
            <img src="../../assets/img/index/choujiang.png" alt />
          </div>
        </div>
      </div>
      <div class="product">
        <van-sticky :offset-top="70">
          <van-tabs v-model="active" @change="tabChange">
            <van-tab v-for="(item,index) in classify" :title="item.name" :key="index">
              <div class="sort">
                <div>
                  <span :class="sortActivity==0?'on':''" @click="sortList(0)">综合</span>
                </div>
                <div>
                  <span :class="sortActivity==1?'on':''" @click="sortList(1)">销量</span>
                </div>
                <div>
                  <span :class="sortActivity==2?'on':''" @click="sortList(2)">价格</span>
                  <img :src="horl ? himg : limg" alt />
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </van-sticky>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset="5"
          :immediate-check="false"
          @load="onLoad"
        >
          <div class="productList">
            <div class="item" @click="jump(6,obj)" v-for="(obj,i) in goodsList" :key="i">
              <div class="img">
                <img :src="obj.original ? obj.original : $store.state.defaultImg" alt />
              </div>
              <div class="main">
                <p>{{obj.goods_name}}</p>
                <h3>
                  <span>¥</span>
                  {{obj.price}}
                </h3>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <fontNav></fontNav>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Tab, Tabs, Dialog, Toast } from "vant";
import fontNav from "../../components/fontNav.vue";
import axios from "axios";
export default {
  name: "index",
  data() {
    return {
      active: 0,
      loading: false,
      finished: false,
      classify: [
        { id: "1", text: "男装" },
        { id: "2", text: "女装" },
        { id: "3", text: "手机" },
        { id: "4", text: "鞋包" },
        { id: "5", text: "电器" },
        { id: "6", text: "食品" },
        { id: "7", text: "酒类" },
        { id: "8", text: "速冻" }
      ],
      bannerList: [],
      tjGoods: [],
      goodsList: [],
      // defaultImg:require('../../assets/localImage/sp1.png'),
      sort: "",
      classIndex: 0,
      page_no: 1,
      page_size: 10,

      sortActivity: 0,
      sortType: "",

      cjxx: {},
      horl: true,
      himg: require("../../assets/img/icon/higher.png"),
      limg: require("../../assets/img/icon/low.png")
    };
  },
  components: {
    fontNav
  },
  created() {
    let indexHref = 0;
    if (localStorage.getItem("index") == null) {
      indexHref = 0;
    } else {
      indexHref = Number(localStorage.getItem("index"));
    }
    indexHref = indexHref + 1;
    localStorage.setItem("index", indexHref);
    this.getwechat();
    this.bannerData();
    this.cjtjGoods();
    this.getList(1);
    this.getcjxx();
    let unionId = this.$route.query.unionId; //'o3cK0t2kKnJoFO6rkSVKrxQYJB4M'
    if (unionId) {
      this.qwxdl(unionId);
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.body.scrollTop = 0;
    });
  },
  methods: {
    qwxdl(unionIdStr) {
      this.getRequest(`passport/login/wechartLogin`, {
        unionid: unionIdStr
      }).then(res => {
        console.log(res.data.code == 1);
        if (res.data.code == 1) {
          Toast(res.data.message);
          let faceStr = this.$route.query.face;
          let nicknameStr = this.$route.query.nickname;
          this.$router.push({
            path: "/login",
            query: { type: 1, face: faceStr, nickname: nicknameStr }
          });
        }
      });
    },
    getcjxx() {
      this.getRequest(`goods/indexDraw`).then(res => {
        console.log();
        this.cjxx = res.data.data;
      });
    },
    onLoad() {
      console.log("qqqqqqq");
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.page_no = this.page_no + 1;
      this.loading = true;
      this.getList(2);
    },
    tabChange(index, title) {
      this.goodsList = [];
      // if(document.getElementById('indexMain').scrollTop>620){
      //   document.getElementById('indexMain').scrollTop = 658;
      // }
      this.classIndex = index;
      this.page_no = 1;
      this.getList(3);
    },

    getwechat() {
      //   let param = {}
      //    param.uuid = this.s20();
      //    console.log(param)
      //    axios({
      //     method: 'get',
      //     url: `http://buyer-api.test.786shop.qiawei.com/api/v1/passport/connect/wechat/auth`,
      //     params: param,
      //     dataType: 'jsonp',
      //     jsonp: 'jsoncallback',
      //     timeout: 5000,
      // })
      // let indexname = localStorage.getItem("index");
      // if(indexname == 1){
      //   window.location.href = "http://buyer-api.test.786shop.qiawei.com/api/v1/passport/connect/wechat/auth"
      // }
      // this.getRequest( `passport/connect/wechat/auth`,param).then(res => {
      //   console.log(res,"wechat");
      // })
    },

    //type 1 第一次进入  2上滑加载  3.切换
    async getList(type) {
      console.log(type, 6666666666666);
      if (type == 1) {
        //初始页面
        let obj = await this.getRequest(`goods/categories/secondLevel`);
        this.classify = obj.data.data;
        let param = {
          category_id: this.classify[0].category_id,
          page_no: this.page_no,
          page_size: this.page_size,
          sort: ""
        };
        console.log(param, 111111111);
        this.getRequest(`goods/search/goodsOfLevelTwo`, param).then(res => {
          if (res.data.code == 1) {
            // this.goodsList = this.goodsList.concat(res.data.data)
            this.loading = false;
            this.finished = true;
          } else {
            this.goodsList = res.data.data;
          }
        });
      } else if (type == 3) {
        console.log(param, 3333);
        let param = {
          category_id: this.classify[this.classIndex].category_id,
          page_no: this.page_no,
          page_size: this.page_size,
          sort: this.sortType
        };
        this.getRequest(`goods/search/goodsOfLevelTwo`, param).then(res => {
          if (res.data.code == 1) {
            this.loading = false;
            this.finished = true;
            this.goodsList = [];
          } else {
            this.goodsList = res.data.data;
            this.loading = false;
            // 数据全部加载完成
            if (res.data.data.length < 10) {
              this.finished = true;
            }
          }
        });
      } else {
        console.log(param, 222);
        let param = {
          category_id: this.classify[this.classIndex].category_id,
          page_no: this.page_no,
          page_size: this.page_size,
          sort: this.sortType
        };
        this.getRequest(`goods/search/goodsOfLevelTwo`, param).then(res => {
          if (res.data.code == 1) {
            // this.goodsList = [];
            this.loading = false;
            this.finished = true;
          } else {
            this.goodsList = this.goodsList.concat(res.data.data);
            this.loading = false;
            // 数据全部加载完成
            if (res.data.data.length < 10) {
              this.finished = true;
            }
          }
        });
      }
    },
    //首页下面商品排序
    sortList(type) {
      this.sortActivity = type;
      this.page_no = 1;

      this.loading = true;
      this.finished = false;
      if (type == 1) {
        this.sortType = "buy_count_desc";
      } else if (type == 2) {
        this.horl = !this.horl;
        if (this.horl) {
          this.sortType = "price_asc";
        } else {
          this.sortType = "price_desc";
        }
      } else if (type == 0) {
        this.sortType = "";
      }
      this.getList(3);
    },

    cjtjGoods() {
      this.getRequest(`goods/search/cjtjGoods`).then(res => {
        this.tjGoods = res.data.data;
      });
    },
    bannerData() {
      this.getRequest(`focus-pictures`, { client_type: "mobile" }).then(res => {
        if (res.data.code != 1) {
          this.bannerList = res.data.data;
        }
      });
    },

    search() {
      this.$router.push({ path: "search" });
    },
    jump(type, obj) {
      switch (type) {
        case 1:
          this.$router.push({ path: "goodsList" , query: { goodType: "point" }  });
          break;
        case 2:
          this.$router.push({ path: "goodsList", query: { is_RakeBack: 1 } });
          break;
        case 3:
          this.$router.push({ path: "goodsKind" });
          break;
        case 4:
          this.$router.push({ path: "businessList" });
          break;
        case 5:
          this.$router.push({ path: "villages" });
          break;
        case 6:
          console.log(obj);
          this.$router.push({
            path: "goodsDetail",
            query: { goods_id: obj.goods_id }
          });
          break;
        case 7:
          this.$router.push({ path: "investCurrency" });
          break;
        case 8:
          if (localStorage.getItem("isLogin") == "true") {
            this.$router.push({ path: "goodsList", query: { is_raffle: 1 } });
          } else {
            this.$router.push({ path: "/login" });
          }
          break;
        case 9:
          this.$router.push({ path: "noticeList" });
          break;
        case 10:
          if (localStorage.getItem("isLogin") == "true") {
            debugger
            this.$router.push({
              path: "LuckDraw",
              query: { luckid: this.cjxx.id ,goods_id: this.cjxx.goods_id}
            });
          } else {
            this.$router.push({ path: "/login" });
          }
          break;
      }
    }
  }
};
</script>
<style lang='less'>
#app{
  height: 100%;
}
body{
  overflow-x: hidden
}
</style>

<style scoped lang='less'>
// html,body,#app{
//   height: 100%;
// }

.index {
  background: #f8f8f8;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
  .indexMain{
    height: calc(100% - 100px);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch
  }

  .search {
    width: 100%;
    height: 140px;
    padding: 36px 20px;
    position: fixed;
    background: #cd0f02;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .input {
      width: 631px;
      height: 68px;
      position: relative;
      input {
        width: 100%;
        height: 100%;
        background: #e2827e;
        border-radius: 34px;
        padding-left: 60px;
        color: #ffffff;
      }
      input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #ffffff;
      }
      img {
        position: absolute;
        left: 24px;
        top: 22px;
        width: 29px;
        height: 28px;
      }
    }
    .xiaoxi {
      display: flex;
      flex-direction: column;
      justify-content: center;
      img {
        width: 42px;
        height: 40px;
        margin-bottom: 4px;
      }
      p {
        font-size: 20px;
        color: #fff;
      }
    }
  }
  .top {
    background: url("../../assets/img/index/bj.png") no-repeat;
    background-size: 100% auto;
    // height: 460px;
    background-color: #ffffff;

    .zw {
      height: 140px;
    }
    .banner {
      width: 707px;
      height: 280px;
      margin: auto;
      border-radius: 5px;
      .my-swipe {
        width: 100%;
        height: 100%;
      }
    }
    .passageway {
      height: 220px;
      display: flex;
      padding: 0 20px;
      justify-content: space-around;
      align-items: center;
      > div {
        .img {
          width: 88px;
          height: 88px;
          margin-bottom: 12px;
        }
        p {
          font-size: 24px;
          color: #6e6e6e;
        }
      }
    }
  }
  .luckDraw {
    margin-top: 20px;
    .cj {
      margin-top: -34px;
      background-image: url("../../assets/img/index/cjbj.png");
      background-size: 100%;
      height: 368px;
      width: 100%;
      .cp {
        width: 100%;
        display: flex;
        justify-content: space-around;
        padding: 35px 20px;
        > div {
          width: 222px;
          height: 300px;
          background-image: url("../../assets/img/index/cjsp.png");
          background-size: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          padding: 10px 0;
          h3 {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #774912;
            padding: 0 10px 0 15px;
          }
          .img {
            width: 178px;
            height: 178px;
            overflow: hidden;
            border-radius: 10px;
          }
          .jq {
            width: 178px;
            height: 40px;
            background: #ffffff;
            color: #ff4444;
            text-align: center;
            line-height: 40px;
            border-radius: 25px;
            font-size: 24px;
          }
        }
      }
    }
    .yl {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 236px;
      > div {
        width: 345px;
        height: 176px;
      }
    }
  }
  .product {
    min-height:calc(100% - 136px);
    // min-height: 1300px;
    /deep/ .van-tab {
      width: auto;
      min-width: auto;
      overflow: visible;
    }
    /deep/ .van-tabs__nav .van-tab .van-tab__text {
      display: flex;
      justify-content: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .sort {
      width: 100%;
      height: 76px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background: #ffffff;
      div {
        text-align: center;
        span {
          font-size: 28px;
          color: #333333;
        }
        span.on {
          color: #ff1919;
        }
        img {
          display: inline-block;
          width: 16px;
          height: 20px;
          margin-left: 10px;
        }
      }
    }
    .productList {
      padding: 10px 18px;
      padding-bottom: 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 348px;
        height: 511px;
        background: #ffffff;
        margin-top: 20px;
        .img {
          width: 348px;
          height: 348px;
        }
        .main {
          padding: 20px;
          height: calc(100% - 348px);
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          h3 {
            span {
              font-size: 22px;
            }
            font-size: 30px;
            font-family: AlibabaPuHuiTiM;
            color: rgba(255, 25, 25, 1);
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>


